import { render } from "./Local.vue?vue&type=template&id=6ee9563c"
import script from "./Local.vue?vue&type=script&lang=js"
export * from "./Local.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/area/overview/Local.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ee9563c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ee9563c', __exports__)) {
    api.reload('6ee9563c', __exports__)
  }
  
  module.hot.accept("./Local.vue?vue&type=template&id=6ee9563c", () => {
    api.rerender('6ee9563c', render)
  })

}


export default __exports__